<template>
    <v-app>
        <v-main>
            <v-container class="fill-height" fluid>
                <v-row align="center" justify="center">
                    <v-col cols="12" md="3" sm="8">
                        <v-card class="elevation-5">
                            <v-form @keyup.native.enter="submitForm">
                                <v-toolbar color="primary" dark flat>
                                    <v-toolbar-title>Zaloguj się do systemu</v-toolbar-title>
                                </v-toolbar>
                                <v-card-text>
                                    <v-text-field label="Nazwa użytkownika" name="login" outlined prepend-inner-icon="mdi-account" type="text" v-model="user.username"></v-text-field>
                                    <v-text-field id="password" label="Hasło" name="password" outlined prepend-inner-icon="mdi-lock" type="password" v-model="user.password"></v-text-field>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn @click="submitForm" color="primary">Zaloguj</v-btn>
                                </v-card-actions>
                            </v-form>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-main>
    </v-app>
</template>

<script>
    export default {
        name: "Login",
        layout: "None",
        data() {
            return {
                user: {
                    username: '',
                    password: ''
                }
            }
        },
        methods: {
            submitForm: function () {
                this.$inertia.post('/login', this.user);
            }
        }
    }
</script>

<style scoped>

</style>
